/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Accesscolumn2Inputs */

const en_coinvestments_share_accesscolumn2 = /** @type {(inputs: Coinvestments_Share_Accesscolumn2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access`)
};

/**
* | output |
* | --- |
* | "Access" |
*
* @param {Coinvestments_Share_Accesscolumn2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_accesscolumn2 = /** @type {((inputs?: Coinvestments_Share_Accesscolumn2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Accesscolumn2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_accesscolumn2(inputs)
});
export { coinvestments_share_accesscolumn2 as "coInvestments_share_accessColumn" }